import { render, staticRenderFns } from "./InnerChatCard.vue?vue&type=template&id=42bbf710&scoped=true"
import script from "./InnerChatCard.vue?vue&type=script&lang=js"
export * from "./InnerChatCard.vue?vue&type=script&lang=js"
import style0 from "./InnerChatCard.vue?vue&type=style&index=0&id=42bbf710&prod&lang=scss"
import style1 from "./InnerChatCard.vue?vue&type=style&index=1&id=42bbf710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbf710",
  null
  
)

export default component.exports